import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

interface TabButtonProps {
  active: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const TabButton = styled.button<TabButtonProps>`
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background-color: ${(props) => (props.active ? '#fff' : '#f0f0f0')};
  color: ${(props) => (props.active ? '#01A8CE' : '#333')};
  border-radius: 5px 5px 5px 5px;
  font-size: 12px;
  font-weight: bold;
  margin-right: 5px;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:focus {
    outline: none;
  }
`;

const TabContent = styled.div`
  padding: 20px;
  margin: 3px;
  border: 0px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  animation: ${fadeIn} 0.5s ease;
`;

const CustomTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <div style={{ display: 'flex', borderBottom: '1px solid #ccc' }}>
        {tabs.map((tab, index) => (
          <TabButton
            key={index}
            onClick={() => handleTabClick(index)}
            active={index === activeTab}
          >
            {tab.title}
          </TabButton>
        ))}
      </div>
      <TabContent>
        {tabs[activeTab].content}
      </TabContent>
    </div>
  );
};

export default CustomTabs;
